"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundBalances = roundBalances;
exports.addTimeBalances = addTimeBalances;
exports.addVacationBalances = addVacationBalances;
exports.addBonusesBalances = addBonusesBalances;
exports.addBalances = addBalances;
exports.makeEmptyTimeBalance = makeEmptyTimeBalance;
exports.makeEmptyVacationBalance = makeEmptyVacationBalance;
exports.makeEmptyBonusesBalance = makeEmptyBonusesBalance;
exports.makeEmptyBalances = makeEmptyBalances;
exports.sumTimeBalances = sumTimeBalances;
exports.sumVacationBalances = sumVacationBalances;
exports.sumBonusesBalances = sumBonusesBalances;
exports.sumBalances = sumBalances;
exports.aggregateTimeBalances = aggregateTimeBalances;
exports.aggregateVacationBalances = aggregateVacationBalances;
exports.aggregateBonusesBalances = aggregateBonusesBalances;
exports.timeBalanceFromDailyResults = timeBalanceFromDailyResults;
exports.vacationBalanceFromDailyResults = vacationBalanceFromDailyResults;
exports.bonusesBalanceFromDailyResults = bonusesBalanceFromDailyResults;
const openapi_1 = require("@pentacode/openapi");
const utils_1 = require("../utils");
function roundTimeBalance(balance) {
    var _a, _b;
    return {
        ...balance,
        work: (0, openapi_1.round)(balance.work, 2),
        absences: (0, openapi_1.round)(balance.absences, 2),
        adjustments: (0, openapi_1.round)(balance.adjustments, 2),
        actual: (0, openapi_1.round)(balance.actual, 2),
        nominal: (0, openapi_1.round)(balance.nominal, 2),
        difference: (0, openapi_1.round)(balance.difference, 2),
        reset: typeof balance.reset === "number" ? (0, openapi_1.round)(balance.reset, 2) : undefined,
        carry: (0, openapi_1.round)((_a = balance.carry) !== null && _a !== void 0 ? _a : 0, 2),
        balance: (0, openapi_1.round)((_b = balance.balance) !== null && _b !== void 0 ? _b : 0, 2),
    };
}
function roundVacationBalance(balance) {
    return {
        ...balance,
        taken: (0, openapi_1.round)(balance.taken, 2),
        adjustments: (0, openapi_1.round)(balance.adjustments, 2),
        actual: (0, openapi_1.round)(balance.actual, 2),
        nominal: (0, openapi_1.round)(balance.nominal, 2),
        difference: (0, openapi_1.round)(balance.difference, 2),
        reset: typeof balance.reset === "number" ? (0, openapi_1.round)(balance.reset, 2) : undefined,
        carry: (0, openapi_1.round)(balance.carry || 0, 2),
        balance: (0, openapi_1.round)(balance.balance || 0, 2),
    };
}
function roundBonusesBalance(balance) {
    return {
        ...balance,
        taxed: (0, openapi_1.round)(balance.taxed, 2),
        untaxed: (0, openapi_1.round)(balance.untaxed, 2),
        actual: (0, openapi_1.round)(balance.actual, 2),
        nominal: typeof balance.nominal !== "undefined" ? (0, openapi_1.round)(balance.nominal, 2) : undefined,
        difference: typeof balance.difference !== "undefined" ? (0, openapi_1.round)(balance.difference, 2) : undefined,
        reset: typeof balance.reset === "number" ? (0, openapi_1.round)(balance.reset, 2) : undefined,
        carry: typeof balance.carry !== "undefined" ? (0, openapi_1.round)(balance.carry, 2) : undefined,
        balance: typeof balance.balance !== "undefined" ? (0, openapi_1.round)(balance.balance, 2) : undefined,
    };
}
/** @deprecated Use `roundTimeBalance`, `roundVacationBalance`, `roundBonusesBalance` instead */
function roundBalances(balances) {
    return {
        ...balances,
        time: roundTimeBalance(balances.time),
        vacation: roundVacationBalance(balances.vacation),
        bonuses: roundBonusesBalance(balances.bonuses),
    };
}
function addTimeBalances(balanceA, balanceB) {
    return {
        ...balanceA,
        carry: (0, openapi_1.add)(balanceA.carry, balanceB.carry),
        actual: (0, openapi_1.add)(balanceA.actual, balanceB.actual),
        nominal: (0, openapi_1.add)(balanceA.nominal, balanceB.nominal),
        difference: (0, openapi_1.add)(balanceA.difference, balanceB.difference),
        work: (0, openapi_1.add)(balanceA.work, balanceB.work),
        absences: (0, openapi_1.add)(balanceA.absences, balanceB.absences),
        adjustments: (0, openapi_1.add)(balanceA.adjustments, balanceB.adjustments),
        balance: (0, openapi_1.add)(balanceA.balance, balanceB.balance),
    };
}
function addVacationBalances(balanceA, balanceB) {
    return {
        ...balanceA,
        carry: (0, openapi_1.add)(balanceA.carry, balanceB.carry),
        actual: (0, openapi_1.add)(balanceA.actual, balanceB.actual),
        nominal: (0, openapi_1.add)(balanceA.nominal, balanceB.nominal),
        difference: (0, openapi_1.add)(balanceA.difference, balanceB.difference),
        taken: (0, openapi_1.add)(balanceA.taken, balanceB.taken),
        adjustments: (0, openapi_1.add)(balanceA.adjustments, balanceB.adjustments),
        balance: (0, openapi_1.add)(balanceA.balance, balanceB.balance),
    };
}
function addBonusesBalances(balanceA, balanceB) {
    var _a, _b, _c, _d;
    return {
        ...balanceA,
        carry: typeof balanceA.carry === "number" && typeof balanceB.carry === "number"
            ? (0, openapi_1.add)(balanceA.carry, balanceB.carry)
            : ((_a = balanceA.carry) !== null && _a !== void 0 ? _a : balanceB.carry),
        actual: (0, openapi_1.add)(balanceA.actual, balanceB.actual),
        nominal: typeof balanceA.nominal === "number" && typeof balanceB.nominal === "number"
            ? (0, openapi_1.add)(balanceA.nominal, balanceB.nominal)
            : ((_b = balanceA.nominal) !== null && _b !== void 0 ? _b : balanceB.nominal),
        difference: typeof balanceA.difference === "number" && typeof balanceB.difference === "number"
            ? (0, openapi_1.add)(balanceA.difference, balanceB.difference)
            : ((_c = balanceA.difference) !== null && _c !== void 0 ? _c : balanceB.difference),
        taxed: (0, openapi_1.add)(balanceA.taxed, balanceB.taxed),
        untaxed: (0, openapi_1.add)(balanceA.untaxed, balanceB.untaxed),
        balance: typeof balanceA.balance === "number" && typeof balanceB.balance === "number"
            ? (0, openapi_1.add)(balanceA.balance, balanceB.balance)
            : ((_d = balanceA.balance) !== null && _d !== void 0 ? _d : balanceB.balance),
    };
}
/** @deprecated Use `addTimeBalance`, `addVacationBalance`, `addBonusesBalance` instead */
function addBalances(balanceA, balanceB) {
    return {
        ...balanceA,
        time: addTimeBalances(balanceA.time, balanceB.time),
        vacation: addVacationBalances(balanceA.vacation, balanceB.vacation),
        bonuses: addBonusesBalances(balanceA.bonuses, balanceB.bonuses),
    };
}
function makeEmptyTimeBalance({ employeeId, from, to }) {
    return {
        employeeId,
        from,
        to,
        carry: 0,
        actual: 0,
        nominal: 0,
        difference: 0,
        work: 0,
        absences: 0,
        adjustments: 0,
        balance: 0,
    };
}
function makeEmptyVacationBalance({ employeeId, from, to, }) {
    return {
        employeeId,
        from,
        to,
        carry: 0,
        actual: 0,
        nominal: 0,
        difference: 0,
        taken: 0,
        adjustments: 0,
        balance: 0,
    };
}
function makeEmptyBonusesBalance({ employeeId, from, to }) {
    return {
        employeeId,
        from,
        to,
        actual: 0,
        taxed: 0,
        untaxed: 0,
    };
}
/** @deprecated Use `makeEmptyTimeBalance`, `makeEmptyVacationBalance`, `makeEmptyBonusesBalance` instead */
function makeEmptyBalances({ employeeId, from, to }) {
    return {
        employeeId,
        from,
        to,
        time: makeEmptyTimeBalance({ employeeId, from, to }),
        vacation: makeEmptyVacationBalance({ employeeId, from, to }),
        bonuses: makeEmptyBonusesBalance({ employeeId, from, to }),
    };
}
function sumTimeBalances(balances) {
    if (!balances.length) {
        return makeEmptyTimeBalance({
            employeeId: 0,
            from: "1970-01-01",
            to: "1970-01-01",
        });
    }
    return balances.reduce((total, each) => addTimeBalances(total, each), makeEmptyTimeBalance(balances[0]));
}
function sumVacationBalances(balances) {
    if (!balances.length) {
        return makeEmptyVacationBalance({
            employeeId: 0,
            from: "1970-01-01",
            to: "1970-01-01",
        });
    }
    return balances.reduce((total, each) => addVacationBalances(total, each), makeEmptyVacationBalance(balances[0]));
}
function sumBonusesBalances(balances) {
    if (!balances.length) {
        return makeEmptyBonusesBalance({
            employeeId: 0,
            from: "1970-01-01",
            to: "1970-01-01",
        });
    }
    return balances.reduce((total, each) => addBonusesBalances(total, each), makeEmptyBonusesBalance(balances[0]));
}
/** @deprecated Use `sumTimeBalance`, `sumVacationBalance`, `sumBonusesBalance` instead */
function sumBalances(balances) {
    if (!balances.length) {
        return makeEmptyBalances({ employeeId: 0, from: "1970-01-01", to: "1970-01-01" });
    }
    return balances.reduce((total, each) => addBalances(total, each), makeEmptyBalances(balances[0]));
}
function aggregateTimeBalances(employee, { from, to }, results, roundValues = true, projected = false) {
    const firstResult = results[0];
    const lastResult = results[results.length - 1];
    const today = (0, utils_1.toDateString)(new Date());
    const firstBalance = (projected && (firstResult === null || firstResult === void 0 ? void 0 : firstResult.date) >= today && (firstResult === null || firstResult === void 0 ? void 0 : firstResult.timeBalancePlanned)) || (firstResult === null || firstResult === void 0 ? void 0 : firstResult.timeBalance);
    const lastBalance = (projected && (lastResult === null || lastResult === void 0 ? void 0 : lastResult.date) >= today && (lastResult === null || lastResult === void 0 ? void 0 : lastResult.timeBalancePlanned)) || (lastResult === null || lastResult === void 0 ? void 0 : lastResult.timeBalance);
    const balance = results.reduce((total, result) => {
        const balance = (projected && result.date >= today && result.timeBalancePlanned) || result.timeBalance;
        return {
            ...addTimeBalances(total, balance),
            employeeId: employee.id,
            from,
            to,
            reset: total.reset,
            carry: total.carry,
            balance: total.balance,
        };
    }, {
        ...makeEmptyTimeBalance({ employeeId: employee.id, from, to }),
        reset: firstBalance === null || firstBalance === void 0 ? void 0 : firstBalance.reset,
        carry: (firstBalance === null || firstBalance === void 0 ? void 0 : firstBalance.carry) || 0,
        balance: (lastBalance === null || lastBalance === void 0 ? void 0 : lastBalance.balance) || 0,
    });
    return roundValues ? roundTimeBalance(balance) : balance;
}
function aggregateVacationBalances(employee, { from, to }, results, roundValues = true) {
    const firstResult = results[0];
    const lastResult = results[results.length - 1];
    const balance = results.reduce((total, result) => {
        return {
            ...addVacationBalances(total, result.vacationBalance),
            employeeId: employee.id,
            from,
            to,
            reset: total.reset,
            carry: total.carry,
            balance: total.balance,
        };
    }, {
        ...makeEmptyVacationBalance({ employeeId: employee.id, from, to }),
        reset: firstResult === null || firstResult === void 0 ? void 0 : firstResult.vacationBalance.reset,
        carry: (firstResult === null || firstResult === void 0 ? void 0 : firstResult.vacationBalance.carry) || 0,
        balance: (lastResult === null || lastResult === void 0 ? void 0 : lastResult.vacationBalance.balance) || 0,
    });
    return roundValues ? roundVacationBalance(balance) : balance;
}
function aggregateBonusesBalances(employee, { from, to }, results, roundValues = true) {
    const firstResult = results[0];
    const lastResult = results[results.length - 1];
    const balance = results.reduce((total, result) => {
        return {
            ...addBonusesBalances(total, result.bonusesBalance),
            employeeId: employee.id,
            from,
            to,
            reset: total.reset,
            carry: total.carry,
            balance: total.balance,
        };
    }, {
        ...makeEmptyBonusesBalance({ employeeId: employee.id, from, to }),
        reset: firstResult === null || firstResult === void 0 ? void 0 : firstResult.bonusesBalance.reset,
        carry: (firstResult === null || firstResult === void 0 ? void 0 : firstResult.bonusesBalance.carry) || 0,
        balance: (lastResult === null || lastResult === void 0 ? void 0 : lastResult.bonusesBalance.balance) || 0,
    });
    return roundValues ? roundBonusesBalance(balance) : balance;
}
function getChunks({ from, to }, resets) {
    const chunks = [];
    let chunkFrom = from;
    for (const reset of resets) {
        chunks.push({
            from: chunkFrom,
            to: reset.date,
        });
        chunkFrom = reset.date;
    }
    chunks.push({
        from: chunkFrom,
        to,
    });
    return chunks;
}
function timeBalanceFromDailyResults(employee, range, results, roundValues = true, projected = false) {
    const balance = aggregateTimeBalances(employee, range, results, roundValues, projected);
    const resets = results.filter((res, i) => i !== 0 && typeof res.timeBalance.reset !== "undefined");
    if (resets.length) {
        const chunks = getChunks(range, resets);
        balance.subBalances = [];
        for (const subRange of chunks) {
            balance.subBalances.push(aggregateTimeBalances(employee, subRange, results.filter((res) => res.date >= subRange.from && res.date < subRange.to), true, projected));
        }
    }
    return balance;
}
function vacationBalanceFromDailyResults(employee, range, results, roundValues = true) {
    const balance = aggregateVacationBalances(employee, range, results, roundValues);
    const resets = results.filter((res, i) => i !== 0 && typeof res.vacationBalance.reset !== "undefined");
    if (resets.length) {
        const chunks = getChunks(range, resets);
        balance.subBalances = [];
        for (const subRange of chunks) {
            balance.subBalances.push(aggregateVacationBalances(employee, subRange, results.filter((res) => res.date >= subRange.from && res.date < subRange.to), true));
        }
    }
    return balance;
}
function bonusesBalanceFromDailyResults(employee, range, results, roundValues = true) {
    const balance = aggregateBonusesBalances(employee, range, results, roundValues);
    const resets = results.filter((res, i) => i !== 0 && typeof res.bonusesBalance.reset !== "undefined");
    if (resets.length) {
        const chunks = getChunks(range, resets);
        balance.subBalances = [];
        for (const subRange of chunks) {
            balance.subBalances.push(aggregateBonusesBalances(employee, subRange, results.filter((res) => res.date >= subRange.from && res.date < subRange.to), true));
        }
    }
    return balance;
}
//# sourceMappingURL=balances.js.map